import React from "react";
import {Button} from "primereact/button";
import {buildProductBriefText} from "../utils/build-codex-prompt";

export default function BriefPreview({brief, translate, onCopy}) {
    const text = buildProductBriefText(brief, translate);
    return (
        <section className="pbb-preview-panel">
            <div className="pbb-panel-header">
                <div>
                    <h2>{translate("pbb-brief-preview")}</h2>
                    <p>{translate("pbb-preview-incomplete")}</p>
                </div>
                <Button icon="pi pi-copy" text rounded onClick={() => onCopy(text)} tooltip={translate("pbb-copy-brief")}/>
            </div>
            <pre>{text}</pre>
        </section>
    );
}
